import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 获取重力感应毁掉数据
 */
export type FabricGetGravityCallbackData = {
  /**
   * 状态 0：不支持 ; 1：成功 ; 2:失败
   */
  status: '0' | '1' | '2';
  /**
   * 重力信息
   */
  gravityInfo?: {
    x: string;
    y: string;
    z: string;
  };
};

/**
 * 获取重力感应信息, 使用异步实现来
 */
export type FabricUtilsGetGravityApi =
  () => Promise<FabricGetGravityCallbackData>;

/**
 * 获取重力感应信息, 使用异步实现来
 */
export const getGravityInfo: FabricUtilsGetGravityApi = () => {
  return new Promise<FabricGetGravityCallbackData>((resolve, reject) => {
    core.call<
      'fabric_utils.getGravityInfo',
      null,
      FabricGetGravityCallbackData
    >('fabric_utils.getGravityInfo', null, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
